/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
	/**
	 *
	 */
	init() {
		// JavaScript to be fired on all pages
		document.body.classList.remove( 'no-js' );
		document.body.classList.add( 'js' );

		/**
		 * Accessibility: New Window/Tab Warnings
		 * Adds visual and screen reader warnings for links that open in a new window/tab
		 */
		( function () {
			/* global pbAccessibility */
			// Check if pbAccessibility is defined
			if ( typeof pbAccessibility === 'undefined' ) {
				return;
			}

			// Track processed links
			const processedLinks = new WeakSet();

			/**
			 * Process all unprocessed links with target="_blank"
			 */
			function processLinks() {
				const links = document.querySelectorAll( 'a[target="_blank"]' );

				links.forEach( link => {
					if ( processedLinks.has( link ) ) {
						return;
					}

					addAccessibilityFeatures( link );
					processedLinks.add( link );
				} );
			}

			/**
			 * Add accessibility features to a link
			 * @param link
			 */
			function addAccessibilityFeatures( link ) {
				// Add visual icon
				addVisualIcon( link );

				// Add screen reader text
				addScreenReaderText( link );
			}

			/**
			 * Add visual icon to indicate new window
			 * @param link
			 */
			function addVisualIcon( link ) {
				const icon = document.createElement( 'span' );
				icon.classList.add( 'pb-external-link-icon' );
				icon.setAttribute( 'aria-hidden', 'true' );
				link.appendChild( icon );
			}

			/**
			 * Add screen reader text for new window warning
			 * @param link
			 */
			function addScreenReaderText( link ) {
				const srText = document.createElement( 'span' );
				srText.classList.add( 'screen-reader-text' );
				srText.textContent = `(${ pbAccessibility.opensNewWindow })`;
				link.appendChild( srText );
			}

			// Initialize on load
			if ( document.readyState === 'loading' ) {
				document.addEventListener( 'DOMContentLoaded', processLinks );
			} else {
				processLinks();
			}

			// Handle dynamically added content (e.g., from AJAX)
			const observer = new MutationObserver( () => {
				processLinks();
			} );

			observer.observe( document.body, {
				childList: true,
				subtree: true,
			} );
		} )();

		/**
		 * getCookie Value
		 * @param name
		 */
		function getCookie( name ) {
			let value = `; ${ document.cookie }`;
			let parts = value.split( `; ${ name }=` );
			if ( parts.length === 2 ) return parts.pop().split( ';' ).shift();
		}

		( function () {
			// document.addEventListener( 'DOMContentLoaded', function () {
			// Sets a -1 tabindex to ALL sections for .focus()-ing
			let sections = document.getElementsByTagName( 'section' );
			for ( let i = 0, max = sections.length; i < max; i++ ) {
				sections[i].setAttribute( 'tabindex', -1 );
				sections[i].className += ' focusable';
			}
		} )();

		// Scroll to anchor, expand parent if present.
		if ( window.location.hash && window.location.hash !== '#' ) {
			const target = document.querySelector( window.location.hash );
			if ( target ) {
				let hiddenParent = target.closest( 'div[hidden]' );
				if ( hiddenParent ) {
					hiddenParent.hidden = false;
					let sectionTitle = hiddenParent.previousElementSibling;
					let sectionTitleButton = sectionTitle.querySelector( 'button' );
					sectionTitleButton.setAttribute( 'aria-expanded', true );
					target.scrollIntoView();
				}
			}
		}

		// Header navigation
		( function () {
			const navToggle = document.querySelector( '.js-header-nav-toggle' );
			if ( navToggle ) {
				navToggle.addEventListener( 'click', function () {
					const expanded = navToggle.getAttribute( 'aria-expanded' ) === 'true' || false;
					navToggle.setAttribute( 'aria-expanded', ! expanded );
					document.querySelector( '.header__nav' ).classList.toggle( 'header__nav--active' );
				} );
			}
		} )();

		( function () {
			// Get all the div.reading-header__toc__title elements
			const headings = document.querySelectorAll(
				'.dropdown > p, .dropdown > div.reading-header__toc__title'
			);

			Array.prototype.forEach.call( headings, heading => {
				// Give each div.reading-header__toc__title a toggle button child
				heading.innerHTML = `
				<button type="button" aria-expanded="false">
					${ heading.innerHTML }
					<svg role="presentation" focusable="false" class="arrow" width="13" height="8" viewBox="0 0 13 8" xmlns="http://www.w3.org/2000/svg"><path d="M6.255 8L0 0h12.51z" fill="currentColor" fill-rule="evenodd"></path></svg>
				</button>
				`;

				// Collapse (hide) the content following the heading
				let content = heading.nextElementSibling;
				content.hidden = true;

				// Assign the button
				let btn = heading.querySelector( 'button' );
				let svg = heading.querySelector( 'button > .arrow' );

				let links = content.querySelectorAll( 'a' );

				// Handle list items and events
				Array.prototype.forEach.call( links, link => {
					// Collapse the content menu if user tabs out.
					/**
					 * @param e
					 */
					link.onblur = e => {
						if ( link === links[links.length - 1] && e.relatedTarget.parentNode.nodeName !== 'LI' ) {
							btn.setAttribute( 'aria-expanded', false );
							content.hidden = true;
						}
					};
				} );

				let $svgArrow = jQuery( 'button[aria-expanded] > svg' );
				let $toggleButton = jQuery( 'button[aria-expanded]' );

				jQuery( $toggleButton, $svgArrow ).on( 'click', function ( e ) {
					// Cast the state as a boolean
					let expanded = btn.getAttribute( 'aria-expanded' ) === 'true' || false;

					if ( btn === e.target || svg === e.target.closest( 'svg' ) ) {
						// Switch the state
						btn.setAttribute( 'aria-expanded', ! expanded );
						// Switch the content's visibility
						content.hidden = expanded;
					} else {
						btn.setAttribute( 'aria-expanded', false );
						content.hidden = true;
					}
				} );

				/**
				 * @param e
				 */
				document.onclick = e => {
					const downloadClass = 'book-header__cover__downloads';
					const $target = jQuery( e.target );
					const $downloadButton = jQuery( `.${ downloadClass }` ).find( 'button' );

					if ( $downloadButton.length === 0
						|| $target.closest( 'div' ).hasClass( downloadClass )
						|| $target.hasClass( 'dropdown-item' ) ) {
						return;
					}

					if ( $downloadButton.attr( 'aria-expanded' ) === 'true' ) {
						btn.setAttribute( 'aria-expanded', false );
						content.hidden = true;
					}
				};

				/**
				 * @param e
				 */
				document.onkeydown = e => {
					// Hide the content when 'Esc' key is pressed (and content is showing)
					if ( e.which === 27 && ! content.hidden ) {
						btn.setAttribute( 'aria-expanded', false );
						content.hidden = true;
					}
				};
			} );
		} )();

		( function () {
			// Get all the part titles
			const entityTitles = document.querySelectorAll(
				'.toc__part--full > .toc__title__container, .toc__chapter--full > .toc__title__container, .toc__front-matter--full > .toc__title__container, .toc__back-matter--full > .toc__title__container'
			);

			// Determine whether or not we are on the home page
			const isHome = document.body.classList.contains( 'home' );

			Array.prototype.forEach.call( entityTitles, entityTitle => {
				// Give each part title a toggle button child
				let ariaExpanded = ( ( isHome && entityTitle.parentNode.classList.contains( 'toc__part' ) ) || ( ! isHome && entityTitle.parentNode.classList.contains( 'toc__parent' ) ) ) ? true : false;
				let ariaLabel = `${ pressbooksBook.toggle_contents } '${ entityTitle.innerText }'`;
				entityTitle.innerHTML = `
				<span>${ entityTitle.innerHTML }</span>
				<button type="button" aria-expanded="${ ariaExpanded }" aria-label="${ ariaLabel }">
					<svg viewBox="0 0 9 9" aria-hidden="true" focusable="false">
						<rect class="vert" height="7" width="1" y="1" x="4" />
						<rect height="1" width="7" y="4" x="1" />
					</svg>
				</button>
				`;

				// Collapse (hide) the content following the heading
				let content = entityTitle.nextElementSibling;
				if ( ariaExpanded === false || ( ! isHome && ! entityTitle.parentNode.classList.contains( 'toc__parent' ) ) ) {
					content.hidden = true;
				} else if ( isHome && entityTitle.parentNode.classList.contains( 'toc__parent' ) ) {
					content.hidden = false;
				}

				// Assign the button
				let btn = entityTitle.querySelector( 'button' );

				/**
				 *
				 */
				btn.onclick = () => {
					// Cast the state as a boolean
					let expanded = btn.getAttribute( 'aria-expanded' ) === 'true' || false;

					// Switch the state
					btn.setAttribute( 'aria-expanded', ! expanded );
					// Switch the content's visibility
					content.hidden = expanded;
				};
			} );
		} )();

		jQuery( $ => {
			const $h5pActivities = $( '.h5p-row-item' );
			const $activityContainer = $( '.h5p-activity-container' );
			$activityContainer.hide();
			$( '#h5p-show-hide' )
				.text( $( '#h5p-show-hide' ).attr( 'show-all-text' ) )
				.attr( 'aria-label', $( '#h5p-show-hide' ).attr( 'show-all-text' ) );
			$( '.h5p-row-item' )
				.text( $( '.h5p-row-item' ).attr( 'show-activity-text' ) )
				.attr( 'aria-label', $( '.h5p-row-item' ).attr( 'show-activity-text' ) );

			$h5pActivities.on( 'click', function () {
				if ( $( this ).text() === $( this ).attr( 'show-activity-text' ) ) {
					$activityContainer.hide();
					$( this ).closest( 'tr' ).next( this ).show( 'slow' );
					$( this )
						.text( $( this ).attr( 'hide-activity-text' ) )
						.attr( 'aria-label', $( this ).attr( 'hide-activity-text' ) );
					window.dispatchEvent( new Event( 'resize' ) );
				} else {
					$( this ).closest( 'tr' ).next( this ).hide();
					$( this )
						.text( $( this ).attr( 'show-activity-text' ) )
						.attr( 'aria-label', $( this ).attr( 'show-activity-text' ) );
				}
			} );

			$( '#h5p-show-hide' ).on( 'click', function () {
				if ( $( this ).text() === $( this ).attr( 'show-all-text' ) ) {
					$activityContainer.show();
					$( this )
						.text( $( this ).attr( 'hide-all-text' ) )
						.attr( 'aria-label', $( this ).attr( 'hide-all-text' ) );
					$( '.h5p-row-item' )
						.text( $( '.h5p-row-item' ).attr( 'hide-activity-text' ) )
						.attr( 'aria-label', $( '.h5p-row-item' ).attr( 'hide-activity-text' ) );
					window.dispatchEvent( new Event( 'resize' ) );
				} else {
					$activityContainer.hide();
					$( this )
						.text( $( this ).attr( 'show-all-text' ) )
						.attr( 'aria-label', $( this ).attr( 'show-all-text' ) );
					$( '.h5p-row-item' )
						.text( $( '.h5p-row-item' ).attr( 'show-activity-text' ) )
						.attr( 'aria-label', $( '.h5p-row-item' ).attr( 'show-activity-text' ) );
				}
			} );
		} );

		const ctaSelector = document.getElementsByClassName( 'cta' );

		/**
		 * toggleHide
		 * @param selector
		 */
		const toggleHide = selector => {
			const cta = selector[0];
			cta.classList.toggle( 'hidden' );
		};

		if ( ! getCookie( 'display_cta' ) && ctaSelector.length > 0 ) {
			toggleHide( ctaSelector );
		}

		const ctaCloseButton = document.getElementById( 'close-cta' );

		if ( ctaCloseButton ) {
			ctaCloseButton.addEventListener( 'click', function ( event ) {
				event.preventDefault();
				const bookPath = window.location.pathname.split( '/' )[1];
				document.cookie = 'display_cta=1; path=/'+bookPath;
				toggleHide( ctaSelector );
			} );
		}
	},
	/**
	 *
	 */
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
